export default "__VITE_ASSET__IE_NjDL7__"